export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#3E2723] text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="rounded-3xl bg-[#2C1810] p-12">
          <div className="grid md:grid-cols-3 gap-12 mb-12">
            <div>
              <h3 className="text-3xl font-light mb-4">Mantente Conectado</h3>
              <p className="text-gray-400 mb-6 leading-relaxed">
                Recibe noticias sobre presentaciones, eventos especiales y consejos para el desarrollo musical de tu hijo.
              </p>
              <div className="space-y-3">
                <input
                  type="email"
                  placeholder="Tu correo electrónico"
                  className="w-full bg-transparent border-b border-gray-600 py-3 focus:border-[#D2691E] focus:outline-none transition-colors text-sm"
                />
                <button className="bg-white text-black px-8 py-3 rounded-full hover:bg-gray-100 transition-all flex items-center gap-2 whitespace-nowrap">
                  <span className="font-semibold">Suscribirse</span>
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>

            <div>
              <h4 className="text-[#D2691E] text-sm font-semibold mb-4 uppercase tracking-wide">Navegación</h4>
              <ul className="space-y-3">
                <li>
                  <button onClick={() => scrollToSection('home')} className="hover:text-[#D2691E] transition-colors underline cursor-pointer">
                    Inicio
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('about')} className="hover:text-[#D2691E] transition-colors underline cursor-pointer">
                    Sobre Nosotros
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('schedule')} className="hover:text-[#D2691E] transition-colors underline cursor-pointer">
                    Horarios
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('contact')} className="hover:text-[#D2691E] transition-colors underline cursor-pointer">
                    Contacto
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-[#D2691E] text-sm font-semibold mb-4 uppercase tracking-wide">Contáctanos</h4>
              <div className="space-y-3 text-gray-300">
                <div>
                  <p className="font-semibold text-white">Emily</p>
                  <p>(956) 635-5295</p>
                </div>
                <div>
                  <p className="font-semibold text-white">Lily</p>
                  <p>(562) 842-6548</p>
                </div>
                <p className="pt-2">info@fortalezamusic.com</p>
                <div className="pt-4">
                  <h4 className="text-[#D2691E] text-sm font-semibold mb-2 uppercase tracking-wide">Ubicación</h4>
                  <p>Plymouth & Fortaleza Church</p>
                  <p>5838 Magnolia Ave. Whittier, CA 90601</p>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex gap-6">
              <a href="#" className="hover:text-[#D2691E] transition-colors underline">
                Facebook
              </a>
              <a href="#" className="hover:text-[#D2691E] transition-colors underline">
                Instagram
              </a>
              <a href="#" className="hover:text-[#D2691E] transition-colors underline">
                YouTube
              </a>
            </div>

            <div className="text-center">
              <p className="text-gray-400">© 2025 Fortaleza Music & Mariachi School</p>
            </div>

            <div className="flex gap-6">
              <a href="#" className="hover:text-[#D2691E] transition-colors underline">
                Privacidad
              </a>
              <a href="#" className="hover:text-[#D2691E] transition-colors underline">
                Términos
              </a>
            </div>
          </div>

          <div className="text-center mt-8 pt-8 border-t border-gray-700">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-[#D2691E] transition-colors text-sm"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
